(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/vikinglotto/assets/javascripts/views/result-page.js') >= 0) return;  svs.modules.push('/modules/vikinglotto/assets/javascripts/views/result-page.js');

'use strict';

svs.vikinglotto.views.ResultPage = Marionette.View.extend({
  viewOptions: ['dateString'],
  dateString: undefined,
  behaviors: [{
    behaviorClass: svs.numbergames.game_app.behaviors.LoadModuleComponent,
    module: 'vikinglotto',
    component: 'result'
  }],
  regions: {
    resultRegion: '#ngResultRegion'
  },
  template() {
    return svs.vikinglotto.templates.result_page();
  },
  initialize() {
    this.mergeOptions(this.options, this.viewOptions);
  },
  onRender() {
    if (svs.vikinglotto.components.result) {
      this.showChildView('resultRegion', new svs.vikinglotto.components.result.views.Result({
        dateString: this.dateString
      }));
    }
  }
});

 })(window);